import BaseModel from "./BaseModel";

class PurchaseTransaction extends BaseModel {
    static route = "purchase-transactions";
}

export default PurchaseTransaction;
